export function encodeHTML(htmlString) {
  const div = document.createElement('div');
  div.innerText = htmlString;
  return div.innerHTML;
}
//# sourceMappingURL=sanitizer.js.map